<template>
<div class="spec-line-robot">

	<div class="align-c btn-rows">
		<template v-for="(sug,sug_i) in suggestions" v-if="sug_index == undefined">
			<btn color="secondary" @click.native="sug_index = sug_i">{{sug.title}}</btn>&nbsp;
		</template>
	</div>

	

	<template v-if="sug_index != undefined">
		<div class="align-c btn-rows">
			<btn color="secondary" @click.native="sug_index = undefined">&larr; Tilbage</btn>
			<br>
			<template v-for="(entry,entry_i) in suggestions[sug_index].entries">
				<btn @click.native="selectEntry(entry)" @mouseover.native="preview = entry" @mouseout.native="preview = undefined" icon-r="+">{{entry.title}}</btn>&nbsp;
			</template>
		</div>
		
	</template>

	<div class="preview" v-if="sug_index != undefined && preview">
		<template v-if="preview">
			<div class="title">{{preview.line.title}} &mdash; {{preview.line.hours}} timer</div>
			<div class="text">{{preview.line.text}}</div>
		</template>
	</div>

</div>
</template>

<script>
import mixins from '../mixins.js'
import Btn from '.././components/Btn'
export default {
	props: [ ],
	mixins: [ mixins.db, mixins.generic ],
	components: {
		Btn,		
	},
	data: function() { return {

		sug_index: undefined,

		preview: undefined,
			
		suggestions: [

			{
				title: 'Workshop',
				entries: [
					{ title: 'Opstartsworkshop', line: { title:'Opstartsworkshop', text:'Der forberedes til og og faciliteres workshop hvor løsningens udformning afklares i detaljegrad.', hours:8 } },
				],
			},
			
			{
				title: 'CMS',
				entries: [
					{ title: 'WordPress CMS', line: { title:'WordPress CMS', text:'Der installeres og opsættes WordPress CMS system som gør det nemt og hurtigt at styre løsningens indhold i form af tekst og billeder.', hours:10 } },
					{ title: 'Headless WordPress', line: { title:'WordPress CMS', text:'Der installeres og opsættes WordPress CMS system som gør det nemt og hurtigt at styre løsningens indhold i form af tekst og billeder. Indhold transporteres fra CMS til selve løsningen via tilpasset REST API.', hours:16 } },
					{ title: 'Custom CMS/admin', line: { title:'Custom CMS', text:'Der udvikles CMS/admin panel hvorfra indhold kan styres.', hours:24 } },
				],
			},

			{
				title: 'Testing',
				entries: [
					{ title: 'Enkel device testing', line: { title:'Enkel device testing', text:'Løsningen testes på de mest udbredte devices, heriblandt desktop, tablet og mobil i nye modeller og med nyeste software/browser.', hours:10 } },
					{ title: 'Udvidet device testing', line: { title:'Enkel device testing', text:'Løsningen testes på de mest udbredte devices, heriblandt desktop, tablet og mobil i nye modeller og med nyeste software/browser.', hours:16 } },
				],
			},

			{
				title: 'Webshop',
				entries: [
					{ title: 'Enkel Shopify', line: { title:'Webshop', text:'Der opsættes e-commerce løsning i Shopify med afsæt i afstemt theme. Valgte theme definerer layout samt tekniske og designmæssige muligheder. Design tilpasses ved styring af typografi og farver.', hours:14 } },
					{ title: 'Enkel WooCommerce', line: { title:'Webshop', text:'Der opsættes custom Woocommerce webshop med skræddersyet theme kodet fra bunden.', hours:68 } },
				],
			},

			{
				title: 'Projektstyring',
				entries: [
					{ title: 'Budget projektstyring', line: { title:'Projektstyring', text:'Projektstyring, dialog og afsluttende overleveringsmøde', hours:6 } },
					{ title: 'Mellem projektstyring', line: { title:'Projektstyring', text:'Projektstyring, dialog, midtvejsmøde og afsluttende overleveringsmøde', hours:12 } },
					{ title: 'Stor projektstyring', line: { title:'Projektstyring', text:'Projektstyring, dialog, midtvejsmøde og afsluttende overleveringsmøde', hours:20 } },
				],
			},

			{
				title: 'Rettelser',
				entries: [
					{ title: 'Mikro', line: { title:'Rettelser', text:'Rettelser foretages i samlet retterunde', hours:6 } },
					{ title: 'Makro', line: { title:'Rettelser', text:'Rettelser foretages i samlet retterunde', hours:12 } },
				],
			},

		],

	} },
	computed: {

		

	},
	methods: {

		selectEntry(entry){

			eventBus.$emit('specLineRobot_onSelectEntry', entry.line)

			this.toast('Tilføjet...')
		},


	}, //methods

	created() {



	},
	mounted(){

		
	},

	destroyed(){

		

	},
}
</script>



// WEBPACK FOOTER //
// SpecLineRobot.vue?5e5a3c5a